const normalize = value => String(value || '').trim().toLowerCase();
export const moneyCents = value => Math.round((Number(value) || 0) * 100);
export const formatOverShortMoney = value => value == null ? '—' : new Intl.NumberFormat('es-PA', { style: 'currency', currency: 'USD' }).format(value);
export const displayServiceDate = value => {
    const parts = String(value || '').split('/');
    return parts.length === 3 ? `${parts[1]}/${parts[0]}/${parts[2]}` : value || '—';
};

// Select once for both the dashboard card and its drill-down.
export function selectOverShortRows(detail, driver, route) {
    if (!detail || !Array.isArray(detail.consolidation) || !Array.isArray(detail.collection_stats)) return null;
    const driverRows = driver ? detail.collection_stats.filter(r => normalize(r.driver_name) === normalize(driver)) : [];
    const source = driverRows.length ? driverRows : detail.consolidation;
    return source.filter(r => (!driver || normalize(r.driver_name) === normalize(driver)) && (!route || normalize(r.route_name) === normalize(route)));
}
export function summarizeOverShort(rows = []) {
    let positive = 0, negative = 0;
    rows.forEach(r => { const amount = moneyCents(r.over_short); if (amount > 0) positive += amount; else negative += amount; });
    return { positive: positive / 100, negative: negative / 100, net: (positive + negative) / 100, count: rows.length };
}
export function filterOverShortRows(rows, { search = '', sign = 'nonzero' } = {}) {
    const query = normalize(search);
    return rows.filter(r => {
        const amount = moneyCents(r.over_short);
        const matchesSign = sign === 'all' || (sign === 'positive' ? amount > 0 : sign === 'negative' ? amount < 0 : amount !== 0);
        return matchesSign && (!query || [r.machine_name, r.machine_id, r.location_name, r.transaction_id, r.driver_name, r.route_name, displayServiceDate(r.service_date)].some(v => normalize(v).includes(query)));
    });
}
export function prepareOverShortRows(rows, group, sort) {
    return rows.map(r => ({ ...r, group_key: group === 'day' ? r.date_key : group === 'machine' ? JSON.stringify([r.machine_id, r.machine_name, r.location_name]) : '' })).sort((a, b) => {
        if (group && a.group_key !== b.group_key) return a.group_key.localeCompare(b.group_key);
        const primary = sort === 'amount' ? Math.abs(moneyCents(b.over_short)) - Math.abs(moneyCents(a.over_short)) : String(a.date_key).localeCompare(String(b.date_key));
        return primary || a.transaction_id.localeCompare(b.transaction_id, undefined, { numeric: true });
    });
}
export function overShortExportRows(rows) {
    return rows.map(r => ({
        Fecha: displayServiceDate(r.service_date), Transacción: r.transaction_id, 'ID máquina': r.machine_id ?? '',
        Máquina: r.machine_name || 'Sin identificar', Ubicación: r.location_name || 'Sin identificar',
        Conductor: r.driver_name || 'Sin identificar', Ruta: r.route_name || 'Sin identificar',
        'Efectivo esperado': r.expected, 'Efectivo recogido': r.collected, 'Sobrante/Faltante': r.over_short,
    }));
}
